var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar",class:{ closeSidebar: !_vm.collapseSidebar },attrs:{"id":"contact-list-sidebar"}},[_c('topsidebar'),_c('newcontactsidebar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }